import {apiClient} from 'common/util/api-client';
import {IndustryKey} from 'common/onboarding/immersive-onboarding/constants';
import {Step} from 'common/onboarding/immersive-onboarding/types';

import {appApiUrl} from '../utils';

export type ImmersiveOnboardingResult = {
  author: string;
  email: string;
  events: [];
  industry: IndustryKey;
  modified: string;
  // TODO: Make these CamelCase
  project_id: number;
  project_token: string;
  steps_completed: Step[];
};

export function getImmersiveOnboardingSetupGuideInfo(projectId: number): Promise<ImmersiveOnboardingResult> {
  return apiClient.get(appApiUrl(`setup-guide`, {projectId}), undefined);
}

export function updateEventSelection(
  projectId: number,
  events: string[],
  industry: IndustryKey,
): Promise<ImmersiveOnboardingResult> {
  return apiClient.patch(appApiUrl(`setup-guide`, {projectId}), {events, industry});
}

export function updateStepsCompleted(projectId: number, stepsCompleted: Step[]) {
  apiClient
    .patch(appApiUrl(`setup-guide/completed-step`, {projectId}), {steps_completed: stepsCompleted})
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
}
